var map = {
	"./accounts.svg": "810e",
	"./accounts_active.svg": "f71c",
	"./alumni.svg": "6db8",
	"./alumni_active.svg": "d8d9",
	"./calendar-active.svg": "7990",
	"./calendar.svg": "200e",
	"./candidates.svg": "20f5",
	"./candidates_active.svg": "93b5",
	"./communication-active.svg": "2322",
	"./communication.svg": "ccce",
	"./dashboard.svg": "4695",
	"./dashboard_active.svg": "47a2",
	"./instructor.svg": "5630",
	"./instructor_active.svg": "ef50",
	"./internship.svg": "3b6f",
	"./internship_active.svg": "1a9c",
	"./leads.svg": "8e7b",
	"./leads_active.svg": "d1b5",
	"./pie-chart-active.svg": "bb2f",
	"./pie-chart.svg": "0d6f",
	"./pitches.svg": "6a80",
	"./pitches_active.svg": "9e5e",
	"./reports.svg": "3958",
	"./reports_active.svg": "02d8",
	"./resumes.svg": "d9f7",
	"./resumes_active.svg": "11f7",
	"./school.svg": "7755",
	"./school_active.svg": "e9ef",
	"./search.svg": "6bd8",
	"./search_active.svg": "3235",
	"./tasks.svg": "017a",
	"./tasks_active.svg": "a8aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b73";